module.exports = __webpack_public_path__ + "img/startBackground.d2ab2365.png";